import produce from 'immer'
import { CardsdestinosAction, CardsdestinosActionTypes } from '../actions/cardsdestinosActions'
import { ApiStatus, ICardsdestinosItem } from '../models'

export const initialCardsdestinosState: ICardsdestinosState = {
  loadingStatus: ApiStatus.NOTLOADED,
  addingStatus: ApiStatus.NOTLOADED,
  searchingStatus: ApiStatus.NOTLOADED,
  searchString: '',
  cardsdestinos: [],
  foundcardsdestinos: [],
  totalDocs: 0,
  errMessage: '',
  errStatus: null,
  errField: null,
}

export default function cardsdestinosReducer(state: ICardsdestinosState = initialCardsdestinosState, action: CardsdestinosAction) {
  return produce(state, (draft) => {
    switch (action.type) {
      case CardsdestinosActionTypes.SEARCH_CARDSDESTINOS:
        draft.searchString = action.searchOptions.searchString
        break
      case CardsdestinosActionTypes.SEARCHING_CARDSDESTINOS:
        draft.searchingStatus = ApiStatus.LOADING
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.NOTLOADED
        break

      case CardsdestinosActionTypes.SEARCHING_CARDSDESTINOS_FAILED:
        draft.searchingStatus = ApiStatus.FAILED
        break

      case CardsdestinosActionTypes.FOUND_CARDSDESTINOS:
        draft.searchingStatus = ApiStatus.LOADED
        action.keep
          ? draft.foundcardsdestinos.push(...action.payload.cardsdestinos.docs)
          : (draft.foundcardsdestinos = action.payload.cardsdestinos.docs)
        draft.totalDocs = action.payload.cardsdestinos.totalDocs
        break

      case CardsdestinosActionTypes.LOAD_CARDSDESTINOS:
      case CardsdestinosActionTypes.LOADING_CARDSDESTINOS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.NOTLOADED
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.foundcardsdestinos = []
        break

      case CardsdestinosActionTypes.LOADING_CARDSDESTINOS_FAILED:
        draft.loadingStatus = ApiStatus.FAILED
        break

      case CardsdestinosActionTypes.LOADED_CARDSDESTINOS:
        draft.loadingStatus = ApiStatus.LOADED
        draft.cardsdestinos = action.payload.cardsdestinos.docs
        draft.totalDocs = action.payload.cardsdestinos.totalDocs
        break

      case CardsdestinosActionTypes.ADD_CARDSDESTINOS:
      case CardsdestinosActionTypes.ADDING_CARDSDESTINOS:
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        draft.errMessage = ''
        draft.errStatus = null
        draft.errField = null
        break

      case CardsdestinosActionTypes.ADDING_CARDSDESTINOS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case CardsdestinosActionTypes.ADDED_CARDSDESTINOS:
        draft.addingStatus = ApiStatus.LOADED
        draft.errStatus = 200
        draft.cardsdestinos.push(action.payload.cardsdestinos.docs[0])
        if (draft.searchString) draft.foundcardsdestinos.push(action.payload.cardsdestinos.docs[0])
        break

      case CardsdestinosActionTypes.REMOVE_CARDDESTINO:
        draft.cardsdestinos.splice(
          draft.cardsdestinos.findIndex((carddestino) => carddestino._id === action.payload._id),
          1
        )
        break

      case CardsdestinosActionTypes.SOFT_REMOVE_CARDSDESTINOS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        break

      case CardsdestinosActionTypes.SOFT_REMOVING_CARDSDESTINOS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case CardsdestinosActionTypes.SOFT_REMOVED_CARDSDESTINOS:
        draft.addingStatus = ApiStatus.LOADED
        draft.cardsdestinos.splice(
          draft.cardsdestinos.findIndex((carddestino) => carddestino._id === action.payload._id),
          1
        )
        break

      case CardsdestinosActionTypes.SOFT_REMOVING_CARDSDESTINOS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break

      case CardsdestinosActionTypes.EDIT_CARDSDESTINOS:
        draft.loadingStatus = ApiStatus.NOTLOADED
        draft.addingStatus = ApiStatus.LOADING
        draft.searchingStatus = ApiStatus.NOTLOADED
        break

      case CardsdestinosActionTypes.EDITING_CARDSDESTINOS:
        draft.loadingStatus = ApiStatus.LOADING
        draft.addingStatus = ApiStatus.LOADING
        break

      case CardsdestinosActionTypes.EDITED_CARDSDESTINOS:
        draft.addingStatus = ApiStatus.LOADED
        draft.cardsdestinos[draft.cardsdestinos.findIndex((carddestino) => carddestino._id === action.payload._id)] = action.payload
        draft.foundcardsdestinos[draft.foundcardsdestinos.findIndex((carddestino) => carddestino._id === action.payload._id)] = action.payload
        break

      case CardsdestinosActionTypes.EDITING_CARDSDESTINOS_FAILED:
        draft.addingStatus = ApiStatus.FAILED
        draft.errMessage = action.message
        draft.errStatus = action.status
        draft.errField = action.field
        break
    }
  })
}

export interface ICardsdestinosState {
  loadingStatus: ApiStatus
  addingStatus: ApiStatus
  searchingStatus: ApiStatus
  searchString: string
  cardsdestinos: ICardsdestinosItem[]
  foundcardsdestinos: ICardsdestinosItem[]
  totalDocs: number
  errMessage?: string
  errStatus?: number
  errField?: string
}
